/* eslint-disable react/jsx-one-expression-per-line */
import React from "react";
import { Paper, Typography, makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import { LoginForm } from "./LoginForm";

/** スタイル定義 */
const useStyles = makeStyles(theme => ({
  main: {
    position: "relative",
    height: "100%",
  },
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -70%)",
    width: "320px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "32px",
  },
  copyright: {
    position: "absolute",
    top: "95%",
    left: "50%",
    transform: "translate(-50%, 0%)",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
}));

/** ログインページ */
export function LoginPage() {
  const classes = useStyles();

  //--------------------
  // コンポーネント
  return (
    <Container component="main" maxWidth="xs" className={classes.main}>
      <Paper elevation={3} className={classes.paper}>
        <Typography component="h1" variant="h5">
          文書検索デモ
        </Typography>
        <LoginForm />
      </Paper>
      <div className={classes.copyright}>
        <Typography variant="body2" color="textSecondary" align="center">
          Copyright © SOUYA co., ltd.
          {new Date().getFullYear()}.
        </Typography>
      </div>
    </Container>
  );
}
